import React from "react";
import { StatusBadge } from "./adminPrimitives";

const statusToneMap = {
  ACTIVE: "success",
  APPROVED: "success",
  AVAILABLE: "success",
  COMPLETE: "success",
  COMPLETED: "success",
  PAID: "success",
  SUCCESS: "success",
  STARTED: "info",
  IN_TRANSIT: "info",
  INTRANSIT: "info",
  ON_TRIP: "info",
  ARRIVED: "info",
  REACHED: "info",
  ASSIGNED: "info",
  ACCEPTED: "info",
  OPEN: "purple",
  BIDDED: "purple",
  BID_PENDING: "purple",
  BID_REQUESTED: "purple",
  PENDING: "warning",
  NEW: "warning",
  REQUESTED: "warning",
  WAITING: "warning",
  PAYMENT_PENDING: "warning",
  INACTIVE: "danger",
  REJECTED: "danger",
  CANCELLED: "danger",
  CANCELED: "danger",
  FAILED: "danger",
  ERROR: "danger"
};

export const normalizeAdminStatus = (status) => String(status || "UNKNOWN").trim().replace(/\s+/g, "_").toUpperCase();

export const formatAdminStatus = (status) => {
  const normalized = normalizeAdminStatus(status);
  if (normalized === "UNKNOWN") return "Unknown";
  return normalized
    .split("_")
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ");
};

export const getAdminStatusTone = (status) => statusToneMap[normalizeAdminStatus(status)] || "info";

const AdminStatusBadge = ({ status, children, tone }) => (
  <StatusBadge tone={tone || getAdminStatusTone(status)}>
    {children || formatAdminStatus(status)}
  </StatusBadge>
);

export default AdminStatusBadge;
